import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/category/CategoryContent.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/bd-mobile-next/styles/category/index.module.scss");
